import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'

import { helpWidget } from '@src/lib/HelpWidget'

const NeedHelp = () => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()

    helpWidget.open()
  }

  return (
    <Box alignItems={'center'} display={'flex'}>
      <Box alignItems={'center'} display={'flex'}>
        <Box mr={2}>
          <QuestionAnswerIcon />
        </Box>
        <Typography variant={'body2'}>
          {I18n.t('auth.needHelpQuestionMark')}
        </Typography>
      </Box>
      <Button onClick={handleClick} variant={'text'}>
        {I18n.t('auth.chatWithOurSupportTeam')}
      </Button>
    </Box>
  )
}

export default NeedHelp
